import {
  Box,
  makeStyles,
  Grid,
  Tooltip,
} from "@material-ui/core";
import { lighten } from "@material-ui/core/styles";

import PropertyPhotosGallery from "./propertyPhotosGallery";
import { createCurrencyField, createNumberFormatField, createTextField } from "@roc/ui";
import { useStore } from "@roc/client-portal-shared/hooks";
import { createDateField, createSelectField, stateOptions } from "@roc/ui/formComponents";
import { observer } from "mobx-react";
import { conditionDetailsOptions, propertyTypeGroupOptions } from "@roc/feature-comp-tool";

const useStyles = makeStyles((theme) => ({
  card: {
    border: `1px solid ${theme.palette.primary.main}`,
    backgroundColor: lighten(theme.palette.primary.main, 0.95),
    borderRadius: "14px",
    padding: "2rem",
  },
  iconBox: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#FFFFFF",
    borderRadius: "100%",
    width: "3rem",
    height: "3rem",
  },
  statusChip: {
    backgroundColor: "#FFFFFF",
    border: "1px solid #2E7D32",
    color: "#2E7D32",
  },
  button: {
    backgroundColor: "#FFFFFF",
    paddingBlock: "0px !important",
    height: "40px",
  },
}));

const SubjectPropertyForm = observer(() => {

  const { compToolStoreV2: compToolStore } = useStore();
  const { editSubjectPropertyFormStore } = compToolStore;
  const subjectProperty = compToolStore.subjectProperty;

  const stateOptionsFiltered = stateOptions.slice(1);//remove select option
  const propertyInformation: any = editSubjectPropertyFormStore.getFlattenedValues();

  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12} lg={4}>
          <PropertyPhotosGallery propertyId={subjectProperty.property_id} images={subjectProperty.data.images} roundedBorders height="347px" />
        </Grid>
        <Grid item xs={12} lg={8}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              {createTextField({
                label: 'Address',
                fieldName: 'address',
                testId: 'address',
                store: editSubjectPropertyFormStore,
                standaloneLabel: false,
                disabled: true
              })}
            </Grid>
            <Grid item xs={12} lg={6}>
              {createTextField({
                label: 'City',
                fieldName: 'city',
                testId: 'city',
                store: editSubjectPropertyFormStore,
                standaloneLabel: false,
                disabled: true
              })}
            </Grid>
            <Grid item xs={12} lg={3}>
              {createSelectField({
                store: editSubjectPropertyFormStore,
                testId: 'state',
                fieldName: 'state',
                label: 'State',
                options: stateOptionsFiltered,
                standaloneLabel: false,
                disabled: true
              })}
            </Grid>
            <Grid item xs={12} lg={3}>
              {createTextField({
                label: 'Zip Code',
                fieldName: 'zipCode',
                testId: 'zipCode',
                store: editSubjectPropertyFormStore,
                standaloneLabel: false,
                disabled: true
              })}
            </Grid>
            <Grid item xs={12} lg={6}>
              {createTextField({
                label: 'County',
                fieldName: 'county',
                testId: 'county',
                store: editSubjectPropertyFormStore,
                standaloneLabel: false,
                disabled: true
              })}
            </Grid>
            <Grid item xs={12} lg={6}>
              {createTextField({
                label: 'Parcel No.',
                fieldName: 'parcel_number',
                testId: 'parcelNo',
                store: editSubjectPropertyFormStore,
                standaloneLabel: false,
                disabled: true
              })}
            </Grid>
            <Grid item xs={6} lg={3}>
              {createNumberFormatField({
                label: 'Rooms',
                fieldName: 'rooms',
                testId: 'rooms',
                store: editSubjectPropertyFormStore,
                standaloneLabel: false,
                thousandSeparator: true,
              })}
            </Grid>

            <Grid item xs={6} lg={3}>
              {createNumberFormatField({
                label: 'Beds',
                fieldName: 'bedrooms',
                testId: 'bedrooms',
                store: editSubjectPropertyFormStore,
                standaloneLabel: false,
                thousandSeparator: true,
              })}
            </Grid>
            <Grid item xs={6} lg={3}>
              {createNumberFormatField({
                label: 'Baths',
                fieldName: 'full_bathrooms',
                testId: 'full_bathrooms',
                store: editSubjectPropertyFormStore,
                standaloneLabel: false,
                thousandSeparator: true,
              })}
            </Grid>
            <Grid item xs={6} lg={3}>
              {createNumberFormatField({
                label: 'Half Baths',
                fieldName: 'half_bathrooms',
                testId: 'half_bathrooms',
                store: editSubjectPropertyFormStore,
                standaloneLabel: false,
                thousandSeparator: true,
              })}
            </Grid>
            <Grid item xs={6} lg={3}>
              {createNumberFormatField({
                label: 'Lot Size',
                fieldName: 'lot_size',
                testId: 'lot_size',
                store: editSubjectPropertyFormStore,
                standaloneLabel: false,
                thousandSeparator: true,
              })}
            </Grid>
            <Grid item xs={6} lg={3}>
              {createCurrencyField({
                label: 'Taxes/Yr.',
                fieldName: 'taxes',
                testId: 'taxes',
                store: editSubjectPropertyFormStore,
                standaloneLabel: false,
              })}
            </Grid>
            <Grid item xs={6} lg={3}>
              {createCurrencyField({
                label: 'Hoa Fees',
                fieldName: 'hoa_fees',
                testId: 'hoa_fees',
                store: editSubjectPropertyFormStore,
                standaloneLabel: false,
                disabled: true
              })}
            </Grid>
            <Grid item xs={6} lg={3}>
              {createNumberFormatField({
                label: 'Parking',
                fieldName: 'parking_type',
                testId: 'parking_type',
                store: editSubjectPropertyFormStore,
                standaloneLabel: false,
                thousandSeparator: true,
                disabled: true
              })}
            </Grid>
          </Grid>
        </Grid>

      </Grid>
      <Grid container spacing={2}>
        <Grid item xs={12} lg={4} >
          <Grid container spacing={2}>
            <Grid item xs={12}>
              {createCurrencyField({
                label: 'Sale Price',
                fieldName: 'price',
                testId: 'price',
                store: editSubjectPropertyFormStore,
                standaloneLabel: false,
                disabled: true
              })}
            </Grid>
            <Grid item xs={12}>
              {createCurrencyField({
                label: 'Rent',
                fieldName: 'rent',
                testId: 'rent',
                store: editSubjectPropertyFormStore,
                standaloneLabel: false,
                disabled: true
              })}
            </Grid>
            <Grid item xs={12}>
              {createSelectField({
                store: editSubjectPropertyFormStore,
                testId: 'condition_tag',
                fieldName: 'condition_tag',
                label: 'Condition',
                options: conditionDetailsOptions,
                standaloneLabel: false
              })}
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} lg={8}>
          <Grid container spacing={2}>
            {compToolStore.rentalComps ?
              (<Grid item xs={6} lg={3}>
                {
                  createCurrencyField({
                    label: 'Rent/Sq.Ft',
                    fieldName: 'sqft_rent',
                    testId: 'sqft_rent',
                    store: editSubjectPropertyFormStore,
                    standaloneLabel: false,
                    disabled: true
                  })
                }
              </Grid>) :
              (
                <Grid item xs={6} lg={3}>
                  {
                    createCurrencyField({
                      label: 'Price/Sq.Ft',
                      fieldName: 'sqft_price',
                      testId: 'sqft_price',
                      store: editSubjectPropertyFormStore,
                      standaloneLabel: false,
                      disabled: true
                    })
                  }
                </Grid>
              )}
            <Grid item xs={6} lg={3}>
              {createNumberFormatField({
                label: 'Sq.Ft',
                fieldName: 'area',
                testId: 'area',
                store: editSubjectPropertyFormStore,
                standaloneLabel: false,
                thousandSeparator: true,
              })}
            </Grid>
            <Grid item xs={6} lg={3}>
              {createNumberFormatField({
                label: 'Year Built',
                fieldName: 'year_built',
                testId: 'year_built',
                store: editSubjectPropertyFormStore,
                standaloneLabel: false,
              })}
            </Grid>
            <Grid item xs={6} lg={3}>
            </Grid>
            <Grid item xs={6} lg={3}>
              {createSelectField({
                store: editSubjectPropertyFormStore,
                testId: 'property_type_group',
                fieldName: 'property_type_group',
                label: 'Property Type',
                options: propertyTypeGroupOptions,
                standaloneLabel: false,
              })}
            </Grid>
            <Grid item xs={6} lg={3}>
              {createTextField({
                label: 'Subject Zoning',
                fieldName: 'subject_zoning',
                testId: 'subject_zoning',
                store: editSubjectPropertyFormStore,
                standaloneLabel: false,
                disabled: true
              })}
            </Grid>
            <Grid item xs={6} lg={3}>
              {createTextField({
                label: 'Property Status',
                fieldName: 'property_status',
                testId: 'property_status',
                store: editSubjectPropertyFormStore,
                standaloneLabel: false,
                disabled: true
              })}
            </Grid>
            <Grid item xs={6} lg={3}>
              {createTextField({
                label: 'Sale Type',
                fieldName: 'sale_type',
                testId: 'sale_type',
                store: editSubjectPropertyFormStore,
                standaloneLabel: false,
                disabled: true
              })}
            </Grid>
            <Grid item xs={6} lg={3}>
              {createDateField({
                label: 'Original List Date',
                fieldName: 'original_list_date',
                testId: 'original_list_date',
                store: editSubjectPropertyFormStore,
                standaloneLabel: false,
                disabled: true
              })}
            </Grid>
            <Grid item xs={6} lg={3}>
              {createCurrencyField({
                label: 'Original List Price',
                fieldName: 'original_list_price',
                testId: 'original_list_price',
                store: editSubjectPropertyFormStore,
                standaloneLabel: false,
                disabled: true
              })}
            </Grid>
            <Grid item xs={6} lg={3}>
              {createDateField({
                label: 'Last Sale Date',
                fieldName: 'last_sale_date',
                testId: 'last_sale_date',
                store: editSubjectPropertyFormStore,
                standaloneLabel: false,
                disabled: true
              })}
            </Grid>
            <Grid item xs={6} lg={3}>
              {createCurrencyField({
                label: 'Last Sale Price',
                fieldName: 'last_sale_price',
                testId: 'last_sale_price',
                store: editSubjectPropertyFormStore,
                standaloneLabel: false,
                disabled: true
              })}
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
});


const TooltipWrapper = ({ children, title }) => {
  return <Tooltip title={title} placement="top-start">
    <Box display="inline-block" width="100%">
      {children}
    </Box>
  </Tooltip>
}

export default SubjectPropertyForm;